// Kaydedilmemiş set değişikliği varken sekme kapatma/yenileme (beforeunload) ve uygulama içi
// gezinme (sol menü/NavLink — BrowserRouter'da useBlocker yok, capture-phase tıklama yakalanır)
// sessizce kaybetmesin (P3-28). Harici link / yeni sekme / modifier tuşu dokunulmaz.

import { useEffect } from "react";

/**
 * Uygulama içi derin bağlantı kapısı: kirli taslakta onay penceresi (gezinme bekler), temizse
 * doğrudan gezinir. Sayfadaki her programatik gezinme bundan geçer (final review FE2).
 */
export function guardedNavigate(
  dirtyCount: number,
  dest: string,
  setPendingNav: (dest: string) => void,
  navigate: (dest: string) => void,
): void {
  if (dirtyCount > 0) setPendingNav(dest);
  else navigate(dest);
}

export function useUnsavedNavGuard(
  dirtyCount: number,
  setPendingNav: (dest: string) => void,
): void {
  useEffect(() => {
    if (dirtyCount === 0) return;
    const onBeforeUnload = (e: BeforeUnloadEvent): void => {
      e.preventDefault();
      e.returnValue = "";
    };
    const onClick = (e: MouseEvent): void => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
        return;
      const a = (e.target as HTMLElement | null)?.closest?.("a[href]");
      if (!(a instanceof HTMLAnchorElement)) return;
      if (a.target && a.target !== "_self") return;
      if (a.origin !== window.location.origin) return;
      const dest = a.pathname + a.search + a.hash;
      if (dest === window.location.pathname + window.location.search + window.location.hash) return;
      e.preventDefault();
      e.stopPropagation();
      setPendingNav(dest);
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    document.addEventListener("click", onClick, true);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      document.removeEventListener("click", onClick, true);
    };
  }, [dirtyCount]);
}
